import { Injectable } from '@angular/core';

const AI_SESSION_STORAGE_KEY = 'eva-ai-session-id';

@Injectable({ providedIn: 'root' })
export class AiAssistantSessionService {
  getSessionId(): string {
    const existingSessionId = sessionStorage.getItem(AI_SESSION_STORAGE_KEY);

    if (existingSessionId) {
      return existingSessionId;
    }

    const sessionId = `sess-${crypto.randomUUID()}`;
    sessionStorage.setItem(AI_SESSION_STORAGE_KEY, sessionId);
    return sessionId;
  }

  getInvestigationId(): string {
    return 'INV-001';
  }
}
